import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { useTranslation } from 'react-i18next';
import { NO_DATA_DISPLAY_NS } from './i18n';

interface NoDataDisplayProps {
  title?: string;
  subtitle?: string;
}

const NoDataDisplay: React.FC<NoDataDisplayProps> = ({ title, subtitle }) => {
  const theme = useTheme();
  const { t } = useTranslation(NO_DATA_DISPLAY_NS);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          mt: 8,
          padding: '8px 32px',
          border: '1px solid #E4E4E4',
          borderRadius: '8px',
        }}
      >
        <ShowChartIcon />
      </Box>
      <Typography
        sx={{
          mt: 2,
          fontSize: '14px',
          lineHeight: '20px',
          color: theme.palette.text.secondary,
        }}
      >
        {title || t('title')}
      </Typography>
      <Typography
        sx={{
          fontSize: '14px',
          lineHeight: '20px',
          color: theme.palette.text.secondary,
        }}
      >
        {subtitle || t('adjustFilter')}
      </Typography>
    </Box>
  );
};

export default NoDataDisplay;
